module.exports = __webpack_public_path__ + "img/qudraTechBlack.82ede669.svg";